import { Box, Label, Text } from '@medely/ui-kit';
import React from 'react';
import { IPosition } from '@medely/types';

type PositionItem = {
  title: string;
  text: string;
};

type PositionsDetailsProps = {
  positions: IPosition[];
};

const PositionItem = ({ title, text }: PositionItem) => {
  return (
    <Box my={2}>
      <Label size="l" color="text.primary" testId="positions-details-info-title">
        {title}
      </Label>
      <Text size="m" color="text.secondary" testId="positions-details-info-text">
        {text}
      </Text>
    </Box>
  );
};

export const PositionsDetails = ({ positions }: PositionsDetailsProps) => {
  return (
    <>
      {positions.map((position) => {
        return (
          <PositionItem
            key={position.id.toString()}
            title={position.display_name}
            text={position.lead_description}
          />
        );
      })}
    </>
  );
};
